app.service("InfoModal", ["$uibModal", function ($uibModal) {
    return {
        /**
         * @param {Object} passedData
         * @param {String} passedData.message
         * @param {String} passedData.title
         * @param {String} [passedData.size]
         */
        show: function (passedData) {

            var message = passedData.message || "";
            var title = passedData.title || false;
            var size = passedData.size || "sm";

            $uibModal.open({
                animation: true,
                templateUrl: _pb + 'components/info-modal/info-modal.html',
                controller: ["$scope", "passedObject", "$uibModalInstance",
                    function ($scope, passedObject, $uibModalInstance) {
                        $scope.message = passedObject.message;
                        $scope.title = passedObject.title;
                        $scope.close = function () {
                            $uibModalInstance.close();
                        }
                    }
                ],
                size: size,
                backdrop: 'static',
                resolve: {
                    passedObject: function () {
                        return {message: message, title: title};
                    }
                }
            });
        }
    };
}]);
